import { render, staticRenderFns } from "./AppTimerWait.vue?vue&type=template&id=40500b56&scoped=true&"
import script from "./AppTimerWait.vue?vue&type=script&lang=js&"
export * from "./AppTimerWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40500b56",
  null
  
)

export default component.exports